import { PMultiSelect } from 'components/prime/PMultiSelect/PMultiSelect';
import styled from 'styled-components';

export const ManageProjectPermissionsUserSearchStyle = {
  PMultiSelect: styled(PMultiSelect)`
    width: 276px;
  `,
};
